import externalAjaxRequest from '~/javascripts/utils/externalAjaxRequest';
import { useEffect, useState } from 'react';

const AsyncProjectCardHeaderImage = ({
  pichaFeaturedPhotosUrl,
  wrapperClassNames,
}) => {
  const [backgroundImageUrl, setBackgroundImageUrl] = useState('');

  useEffect(() => {
    externalAjaxRequest({
      dataType: 'json',
      url: pichaFeaturedPhotosUrl,
      type: 'GET',
      success: (data) => {
        setBackgroundImageUrl(`url("${Object.values(data).pop()}")`);
      },
    });
  }, []);

  return (
    <div
      className={wrapperClassNames}
      style={{
        backgroundImage: backgroundImageUrl,
      }}
    />
  );
};

export default AsyncProjectCardHeaderImage;
